import styles from "./Page17.module.css";

const Page17 = () => {
  return (
    <main className={styles.main}>
      <div className={styles.wrapper}>
        <h1 className={styles.title}>Zugangsanfrage</h1>
        <div className={styles.contentWrapper}>
          <p className={styles.text}>
            Der Zugang zu Re-Aging erfolgt ausschließlich auf Anfrage und nach
            persönlicher Qualifikation. Wir begleiten eine limitierte Anzahl
            ausgewählter Klient:innen und Unternehmen, um höchste
            Individualisierung, Diskretion und nachhaltige Ergebnisse zu
            gewährleisten.
          </p>
          <div className={styles.btnWrapper}>
            <button className={styles.btn}>
              Apply for Re-Aging & Metabolic
            </button>
            <button className={styles.btn}>
              Apply for Re-Brain (Unternehmen)
            </button>
          </div>
          <p className={styles.text}>
            Alle Anfragen werden vertraulich behandelt. Sie können Ihre Anfrage
            optional anonym stellen. Nach Eingang melden wir uns für ein erstes
            Gespräch.
          </p>
        </div>
        <p className={styles.mediaInfo}>
          Für priorisierten Zugang zu unseren limitierten VIP-Programmen
          kontaktieren Sie uns bitte direkt unter vip@re-aging.ch
        </p>
      </div>
    </main>
  );
};

export default Page17;
